<template>
  <div class="aside-box">
    <div class="floor-name">
      <div class="info-name">
        <span>*</span>
        <p>楼层名称</p>
      </div>
      <div class="info-content">
        <el-input
          v-model.trim="info.name"
          placeholder="请输入楼层名称"
          maxlength="6"
          show-word-limit
          class="floor-name-input"
          @input="updateVuex()"
        ></el-input>
      </div>
    </div>
    <div class="floor-style">
      <div class="info-name">
        <span style="opacity: 0">*</span>
        <p>样式</p>
      </div>
      <div class="info-content">
        <el-radio-group v-model="info.style" @change="updateVuex()">
          <el-radio :label="3">竖版列表</el-radio>
          <el-radio :label="4">横版列表</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="floor-body">
      <div class="info-name">
        <span style="opacity: 0">*</span>
        <p>内容</p>
      </div>
      <div class="info-content">
        <div class="info-content-item">
          <p>内容来源</p>
          <el-radio-group v-model="info.contentOrigin" @change="changeRule">
            <el-radio :label="1">默认规则</el-radio>
            <el-radio :label="2">自定义规则</el-radio>
          </el-radio-group>
        </div>
        <div
          v-show="info.contentOrigin == 1"
          class="info-content-item"
          style="align-items: flex-start; margin: 0"
        >
          <p>排序维度</p>
          <el-radio-group
            v-model="info.order"
            class="group-type2"
            @input="getContentList()"
          >
            <el-radio label="downloads$2">按总下载排序</el-radio>
            <el-radio label="month_downloads$2">按30天内下载排序</el-radio>
            <el-radio label="create_time$2">按创建时间排序</el-radio>
          </el-radio-group>
        </div>
        <div
          v-show="info.contentOrigin == 1"
          class="info-content-item info-content-item2"
        >
          <span>*</span>
          <p>展示数量</p>
          <el-input
            v-model="info.count"
            :placeholder="'最多展示' + info.maxCount + '个'"
            show-word-limit
            @input="changeContentCount"
            @change="getContentList()"
            class="floor-name-input"
          ></el-input>
        </div>
        <div class="zdy-content" v-show="info.contentOrigin == 2">
          <ul class="content-list" id="content-list">
            <li
              class="content-li"
              v-for="(item3, index) in info.contentList"
              :key="index"
            >
              <p>
                {{ item3.title }}
              </p>
              <div
                class="del-content-icon"
                @click="delSelectContent(index)"
              ></div>
            </li>
          </ul>
          <div class="add-content-li" @click="addDIYContent()">
            <span>+</span>
            <p>添加内容</p>
            <div>
              （{{ info.contentList ? info.contentList.length : 0 }}/{{
                info.maxCount
              }}）
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/assets/js/api";
import Sortable from "sortablejs";
export default {
  name: "ShopCenterAdminWebMAsideArticle",
  props: {
    floor: {
      type: Object,
    },
  },
  data() {
    return {
      info: {
        name: "资料", // 楼层名称
        type: "资料", // 楼层类型
        style: 1, // 1-缩略图 2-列表
        contentOrigin: 1, // 1-默认 2-自定义
        order: "pv$2", // 排序字段
        count: 2, // 展示数量
        maxCount: 6, // 最大展示数量
        contentList: [], // 楼层内容列表
      },
      DIYContentList: [], // 自定义内容的列表
    };
  },
  watch: {
    "$store.state.mDecoration.currentFloor": {
      handler(newValue) {
        this.info = JSON.parse(JSON.stringify(newValue));
      },
      immediate: true,
      deep: true,
    },
    floor: {
      handler() {
        // 清空之前的DIYContentList缓存
        this.DIYContentList = [];
        if (this.info.contentOrigin == 1) {
          this.getContentList();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    shopId() {
      return this.$store.state.user.userInfo.shopId;
    },
  },
  mounted() {},

  methods: {
    // 更新数据到vuex中
    updateVuex() {
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      list[this.floor.index] = this.info;
      this.$store.commit("mDecoration/setFloorList", list);
      this.$store.commit("mDecoration/setCurrentFloor", this.info);
    },
    // 修改内容来源
    changeRule(e) {
      // console.log("内容来源修改---", e);
      if (e === 2) {
        // 内容数组替换为自定义内容数据
        this.info.contentList = this.DIYContentList;
        this.info.order = "downloads$2";
        // 清空内容数组
        // this.info.contentList = [];
        // 更新数据到vuex中
        this.updateVuex();
        // 开启拖拽排序
        var el = document.getElementById("content-list");
        new Sortable(el, {
          animation: 150,
          filter: ".no-change",
          onUpdate: (evt) => {
            // 改变数组排序
            const temp = this.info.contentList[evt.oldIndex];
            this.info.contentList.splice(evt.oldIndex, 1);
            this.info.contentList.splice(evt.newIndex, 0, temp);
            const list = JSON.parse(
              JSON.stringify(this.$store.state.mDecoration.floorList)
            );
            list[this.floor.index] = this.info;
            this.$store.commit("mDecoration/setFloorList", list);
            // 重新按顺序渲染dom 确保视图和数据一致
            const arr = this.info.contentList.slice(0);
            this.info.contentList = [];
            this.$nextTick(() => {
              this.info.contentList = arr;
            });
          },
        });
      } else {
        // 存储自定义选择的数据
        this.DIYContentList = this.info.contentList;
        this.info.count = 2;
        // 获取内容数据
        this.getContentList();
      }
    },
    // 获取楼层内容列表
    async getContentList() {
      if (this.info.count == "" || this.info.count == 0) {
        this.info.contentList = [];
      } else {
        // 获取资料列表
        const res = await this.$axios.post(
          api.decoration.getVideoOrResourceList,
          {
            shopId: Number(this.shopId),
            queryType: 1, // 1-资料 2-视频
            pageIndex: 1,
            pageSize: this.info.count,
            sortRule: this.info.order,
          }
        );

        this.info.contentList = res.list || [];
      }
      // 更新数据到vuex中
      this.updateVuex();
    },
    // 修改楼层内容数量
    changeContentCount(e) {
      if (!e) {
        this.info.count = "";
        return;
      }
      // 判断是否为纯数字的正则表达式
      const reg = /^[0-9]*$/;
      while (!reg.test(e) || Number(e) > this.info.maxCount) {
        // e = e.slice(0, e.length - 1);
        e = this.info.maxCount;
        this.info.count = Number(e);
      }
      // 重新获取数据
      // this.getContentList();
    },
    // 选择自定义内容
    addDIYContent() {
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setCurrentFloor", this.info);
      this.$store.commit("mDecoration/setDialogType", "diyContent");
    },
    // 删除已选择的自定义内容
    delSelectContent(index) {
      // 删除数据
      this.info.contentList.splice(index, 1);
      // 更新数据总量
      this.info.count = this.info.contentList.length;
      // 更新数据到vuex中
      this.updateVuex();
    },
  },
};
</script>

<style lang="scss" scoped>
.aside-box {
  .floor-name,
  .floor-style {
    margin-bottom: 40px;
  }
  .info-name {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;

    span {
      margin-right: 4px;
      font-size: 15px;
      font-weight: 600;
      color: #fe4509;
    }
    p {
      font-size: 15px;
      font-weight: 500;
      color: #606266;
    }
  }
  .info-content {
    padding-left: 12px;

    .info-content-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 24px;

      & > span {
        margin-right: 4px;
        font-size: 15px;
        font-weight: 600;
        color: #fe4509;
      }

      & > p {
        width: 80px;
        font-size: 12px;
        color: #606266;
      }
      & > div {
        width: 220px;
      }

      ::v-deep .el-radio-group.group-type2 .el-radio {
        margin-bottom: 20px;
      }
    }

    .info-content-item2 {
      transform: translateX(-12px);
    }

    .zdy-content {
      .content-list {
        .content-li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 280px;
          height: 32px;
          padding: 0 15px;
          margin-bottom: 15px;
          background: #f5f5f5;
          border-radius: 5px;

          p {
            width: 250px;
            font-size: 12px;
            color: #606266;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .del-content-icon {
            width: 11px;
            height: 12px;
            background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
              no-repeat;
            background-size: 100% 100%;
            cursor: pointer;

            &:hover {
              background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }

    .nav-list {
      .nav-li {
        width: 278px;
        height: 180px;
        padding: 15px 15px;
        margin-bottom: 20px;
        background: #ffffff;
        border: 1px dashed transparent;

        .nav-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          p {
            font-weight: 500;
            font-size: 13px;
            color: #606266;
          }

          .del-nav-icon {
            display: none;
            width: 11px;
            height: 12px;
            background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
              no-repeat;
            background-size: 100% 100%;
            cursor: pointer;

            &:hover {
              background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        &:hover {
          border: 1px dashed #c0d0ff;
          box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
          border-radius: 5px;

          .del-nav-icon {
            display: block;
          }
        }
        .nav-body {
          margin-top: 15px;

          & > div {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            p {
              width: 70px;
              font-size: 12px;
              color: #606266;
              white-space: nowrap;
            }
          }
          .nav-name {
            margin-bottom: 15px;
            span {
              margin-left: -9px;
              margin-right: 4px;
              font-size: 12px;
              font-weight: 600;
              color: #fe4509;
            }
            .nav-name-input {
              width: 210px;
            }
          }

          .nav-img {
            margin-bottom: 15px;

            .nav-img-box {
              position: relative;
              width: 30px;
              height: 30px;
              margin-right: 10px;
              border-radius: 5px;
              background-size: 100% 100%;
              transition: all 0.2s linear;

              .del-img-box {
                display: none;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0px;
                right: 0px;
                left: 0px;
                bottom: 0px;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.4);
                border-radius: 5px;

                .del-img-icon {
                  width: 11px;
                  height: 12px;
                  background: url(../../../assets/images/pc-decoration/del-floor-icon3.png)
                    no-repeat;
                  background-size: 100% 100%;
                  cursor: pointer;

                  &:hover {
                    background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                      no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }

              &:hover {
                .del-img-box {
                  display: flex;
                }
              }
            }

            .add-img-box {
              width: 30px;
              height: 30px;
              margin-right: 10px;
              background: #ffffff;
              border: 1px dashed #a3baff;
              border-radius: 5px;
              font-size: 18px;
              text-align: center;
              line-height: 28px;
              font-weight: 500;
              color: #5a83ff;
              cursor: pointer;
            }
            .nav-img-tips {
              width: 175px;
              font-size: 12px;
              color: #c4c8d0;
            }
          }

          .nav-url {
            .nav-url-input {
              width: 210px;
            }
          }
        }
      }
    }

    .swiper-list {
      .swiper-li {
        .swiper-body {
          .swiper-img {
            .swiper-img-show {
              width: 210px;
              height: 40px;
              border-radius: 5px;
            }
            .create-swiper-btn {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 210px;
              height: 30px;
              background: #ffffff;
              border: 1px solid #a2baff;
              border-radius: 5px;
              cursor: pointer;

              .create-swiper-icon {
                width: 9px;
                height: 12px;
                margin-right: 5px;
              }

              p {
                font-size: 12px;
                color: #5a83ff;
              }
            }
          }
          .swiper-tips {
            margin-bottom: 15px;
            color: #c4c8d0;
          }
        }
      }
    }
    .show-shop-info {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      .shop-info-title {
        width: 70px;
        margin-right: 12px;
        font-size: 12px;
        color: #606266;

        span {
          font-weight: 600;
          font-size: 12px;
          color: #fe4509;
        }
      }
      .shop-info-list {
        width: 230px;
        overflow: hidden;

        .shop-info-li {
          float: left;
          width: 75px;
          margin-bottom: 10px;

          ::v-deep .el-checkbox__label {
            font-size: 12px;
            color: #606266;
          }
        }
      }
    }
    .info-origin {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 20px;
      .info-title {
        width: 70px;
        margin-right: 12px;
        font-size: 12px;
        color: #606266;

        span {
          font-weight: 600;
          font-size: 12px;
          color: #fe4509;
        }
      }
      ::v-deep .el-input--suffix .el-input__inner {
        width: 220px;
      }
      ::v-deep .el-scrollbar__wrap {
        overflow-x: auto !important;
      }
    }
    .info-order {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      .info-title {
        width: 70px;
        margin-right: 12px;
        font-size: 12px;
        color: #606266;

        span {
          font-weight: 600;
          font-size: 12px;
          color: #fe4509;
        }
      }

      ::v-deep .el-radio-group {
        width: 220px;

        .el-radio {
          margin-bottom: 20px;
        }
      }
    }
    .add-content-li {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 310px;
      height: 32px;
      margin-bottom: 30px;
      background: #ffffff;
      border: 1px dashed #5a83ff;
      border-radius: 5px;
      cursor: pointer;

      span {
        font-size: 20px;
        font-weight: 500;
        transform: translate(-2px, -2px);
        color: #5a83ff;
      }

      p {
        font-size: 14px;
        color: #5a83ff;
      }
      div {
        font-size: 12px;
        color: #c4c8d0;
      }

      .edit-icon {
        width: 9px;
        height: 12px;
        margin-right: 5px;
      }
    }
  }
}
</style>
